export default "__VITE_ASSET__CKuujuZ2__"